import { useEffect } from 'react';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';

import routeData from 'src/routes/routes';

const App = () => {
  useEffect(() => {
    if (import.meta.env.VITE_PLATFORM === 'lula') {
      document.title = 'Lula Schedule Tenant';
    }
    if (import.meta.env.VITE_PLATFORM === 'foresight') {
      document.title = 'Foresight ';
    }
  }, []);

  const router = createBrowserRouter(routeData);
  return <RouterProvider router={router} />;
};

export default App;
